import { all, call, put, takeEvery } from 'redux-saga/effects'
import { setPrimaryApprover } from 'Store/Identity/PrimaryApprover/PrimaryApproverAction';
import { GET_PRIMARY_APPROVER } from 'Store/Identity/PrimaryApprover/PrimaryApproverType';
import UserManagementApiService from 'client/utils/clientApiHelper'
import { setSecondaryApprover } from 'Store/Identity/SecondaryApprover/SecondaryApproverAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getPrimaryApprover(req: any): any {
    try {
        let payloadData : IPayload = {
            apiType : apiType.Identity,
            endpoint : `users/approvalusers?searchText=${req.val}`,
            apiMethod :  apiMethod.GET,
            payload : null
           
        }
        const response = yield call(
            UserManagementApiService.callUserPost,API_URL.PostWebApp,payloadData
        );
        if (response && req?.typeVal == "Primary") {
            yield put(setPrimaryApprover(response));
        }else if(response && req?.typeVal == "secondary") {
            yield put(setSecondaryApprover(response));
        }

    } catch (error) {
        yield put(setPrimaryApprover([]))
    }
}

function* watchPrimaryApprover() {
    yield takeEvery(GET_PRIMARY_APPROVER, getPrimaryApprover);
}

export default function* combinedSaga() {
    yield all([
        watchPrimaryApprover()
    ])
}
